import React, { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import fingerprint from "../../assets/images/fingerprint.svg";
import supply from "../../assets/images/supply.svg";
import { useWeb3React } from "@web3-react/core";
import alertCircle from "../../assets/images/alertCircle.svg";
import claimedIcon from "../../assets/images/claimed.svg";
import { connectors } from "../../connectors";
import { useGCtx } from "../../Contexts/GlobalContext";
import metamaskIcon from "../../assets/images/metamaskIcon.png";
import walletconnectIcon from "../../assets/images/walletconnectIcon.png";
import ClaimBlock from "../../Components/ClaimBlock/ClaimBlock";
import sampleNFT from "../../assets/images/SampleNFT.png";
const BASE_URL = "https://api.mintnft.today";
const URL = "https://polygonconnect.up.railway.app/api";

const Claimpage = () => {
  const { wallet, setWallet } = useGCtx();
  const [mintedTokenId, setMintedTokenId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isClaimed, setIsClaimed] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Please wait...");
  const { active, activate, account } = useWeb3React();
  const [totalClaimed, setTotalClaimed] = useState(0);
  const [error, setError] = useState("");

  const setProvider = (type) => {
    window.localStorage.setItem("provider", type);
  };
  useEffect(() => {
    if (error.length) {
      console.log(error);
      setTimeout(() => {
        setError("");
      }, 5000);
    }
  }, [error]);

  useEffect(() => {
    if (active) {
      setWallet(account);
    }
    //eslint-disable-next-line
  }, [active]);

  useEffect(() => {
    console.log(localStorage.getItem("Claimed"));
    if (
      localStorage.getItem("Claimed") &&
      localStorage.getItem("Claimed") === true
    ) {
      setIsClaimed(true);
      return;
    }
  }, []);

  const fetchUserStatus = async () => {
    setIsLoading(true);
    setLoadingMessage("Checking your status...");

    const res = await fetch(`${URL}/status/${wallet}`);
    const data = await res.json();
    if (data.data === true) {
      setIsClaimed(true);
      data?.tokenID !== false && setMintedTokenId(data.tokenID);
    }
    setIsLoading(false);
  };

  const UpdateStatus = async (tokenID) => {
    const res = await fetch(`${URL}/update/mint/${wallet}/${tokenID}`);
    const data = await res.json();
    localStorage.setItem("Calimed", true);
    console.log(data);
  };

  const count = async () => {
    const res = await fetch(`${URL}/count`);
    const data = await res.json();
    setTotalClaimed(data.count);
  };

  useEffect(() => {
    count();
    // setTotalClaimed(tempCount.count);
    if (wallet) {
      fetchUserStatus();
    }
    //eslint-disable-next-line
  }, [wallet]);

  const generateTicket = async () => {
    try {
      const generateCall = await fetch(`${URL}/ticket`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          wallet: wallet,
        }),
      });
      if (generateCall.status === 400) {
        setError("You have already claimed your ticket");
        setIsLoading(false);
        return false;
      }
      const generateCallRes = await generateCall.blob();
      return generateCallRes;

      // return tempRes;
    } catch (error) {
      console.log(error);
    }
  };

  const claim = async () => {
    try {
      setIsLoading(true);
      setLoadingMessage("Claiming...");
      const tempImage = await generateTicket();
      if (!tempImage) {
        setError("Unable to Generate ticket");
        setIsLoading(false);
        return;
      }
      if (tempImage?.size < 500) {
        setError("Unable to Generate ticket");
        setIsLoading(false);
        return;
      }
      // setLoadingMessage("Uploading your ticket to IPFS...");

      var file = new File([tempImage], "file.png");

      const metadata = {
        name: "Polygon Connect Ticket - India",
        description:
          "Polygon Connect is a global initiative that unites every part of Polygon’s ecosystem via live events, hackathons, and community gatherings. Please ensure that you've registered with your email ID before claiming the ticket.",
        external_link: "",
        attributes: [],
      };

      const image = file;
      const asset = file;
      const formData = new FormData();
      formData.append("image", image);
      formData.append("asset", asset);
      formData.append("metadata", JSON.stringify(metadata));
      try {
        const uploadingCall = await fetch(`${BASE_URL}/v1/upload/single`, {
          method: "POST",
          headers: {
            "x-api-key": "d37e0d58-2541-40ac-87c1-a51f2618c26d",
          },
          body: formData,
        });

        const uploadResponse = await uploadingCall.json();

        // setNftData({name:"",description:"",external_link:"",isAdded:false})
        console.log(uploadResponse);
        if (uploadResponse.data && uploadResponse.data.url) {
          const ipfsLink = uploadResponse.data.url;

          const type = "ERC721";
          const network = "mainnet";
          const amount = 1;
          const tokenCategory = null;
          const bodyData = {
            wallet,
            type,
            amount,
            network,
            tokenUri: ipfsLink,
            tokenCategory,
          };
          // setLoadingMessage("Minting...");

          try {
            const mintCall = await fetch(`${BASE_URL}/v1/mint/single`, {
              method: "POST",
              headers: {
                "x-api-key": "d37e0d58-2541-40ac-87c1-a51f2618c26d",
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(bodyData),
            });

            const mintResponse = await mintCall.json();
            if (mintResponse && mintResponse.data) {
              if (mintResponse.data.status === "CONFIRMED") {
                // Done
                setIsLoading(false);
                setIsClaimed(true);
                UpdateStatus(mintResponse.data.tokenId);
                setMintedTokenId(mintResponse.data.tokenId);
              } else {
                // Pending
                setIsLoading(false);
                setIsClaimed(true);
                UpdateStatus();
                setError("NFT will be airdropped to your wallet soon");
              }
            } else {
              if (mintResponse.message === "Please retry txn") {
                try {
                  const mintCall = await fetch(`${BASE_URL}/v1/mint/single`, {
                    method: "POST",
                    headers: {
                      "x-api-key": "d37e0d58-2541-40ac-87c1-a51f2618c26d",
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(bodyData),
                  });

                  const mintResponse = await mintCall.json();
                  if (mintResponse && mintResponse.data) {
                    if (mintResponse.data.status === "CONFIRMED") {
                      // Done
                      setIsLoading(false);
                      setIsClaimed(true);
                      setMintedTokenId(mintResponse.data.tokenId);

                      UpdateStatus(mintResponse.data.tokenId);
                    } else {
                      // Pending
                      setIsLoading(false);
                      setIsClaimed(true);
                      UpdateStatus();
                      setError("NFT will be airdropped to your wallet soon");
                    }
                  } else {
                    setIsLoading(false);
                  }
                } catch (e) {
                  setIsLoading(false);
                }
              }
            }
          } catch (e) {
            console.log(e);
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
        }
      } catch (e) {
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section className=" flex h-[100%] md:h-screen w-full relative">
      <ClaimBlock>
        <div className="w-full mx-auto h-full  lg:h-[100%] md:w-[40%] lg:w-[50%] max-w-[360px] md:max-w-[400px] lg:max-w-[50%]  gradp2 rounded-2xl md:overflow-y-auto md:overflow-x-hidden relative">
          <div className="image__container mx-auto text-center w-full h-full">
            <img
              src={sampleNFT}
              alt=""
              className="h-full w-full object-contain mx-auto rounded-xl "
            />
          </div>
        </div>
        <div className="w-full md:h-[100%] lg:w-[60%] md:w-[50%] p-4 flex items-center md:overflow-y-auto">
          <div className="w-full">
            {error ? (
              <div className="flex font-semibold text-[#333333] items-center  w-full py-3 bg-[#FFB5B5] rounded-lg p-2 my-2">
                <img src={alertCircle} className="h-6 mr-2" alt="" />{" "}
                <p>{error}</p>
              </div>
            ) : null}
            <h2 className="text-3xl font-black md:text-5xl  py-5 ">
              Polygon Connect Ticket - India
            </h2>
            <div className="claimprops flex items-center gap-2 flex-wrap font-regular gt-w ">
              <div className="claimprop rounded-lg overflow-hidden w-auto  ">
                <div className="prop flex items-center gap-1 text-white justify-center text-[14px] md:text-[16px] bg-[#A673EF] p-2 px-3">
                  <img src={claimedIcon} className="h-4 mr-1" alt="" />
                  {totalClaimed} Claimed
                </div>
              </div>
              <div className="claimprop w-auto  rounded-lg overflow-hidden">
                <div className="prop flex items-center gap-1 text-white justify-center text-[14px] md:text-[16px] bg-[#A673EF] p-2 px-3">
                  <img src={fingerprint} className="h-4 mr-1" alt="" />
                  Public Access
                </div>
              </div>
              <div className="claimprop rounded-lg overflow-hidden w-auto  ">
                <div className="prop flex items-center gap-1 text-white justify-center text-[14px] md:text-[16px] bg-[#A673EF] p-2 px-3">
                  <img src={supply} className="h-4 mr-1" alt="" />
                  2500 Supply
                </div>
              </div>
            </div>
            {!isClaimed ? (
              <p className="font-medium text-[#1e1e1e] text-[16px] md:text-[18px] py-3 gt-w">
                Polygon Connect is a global initiative that unites every part of
                Polygon’s ecosystem via live events, hackathons, and community
                gatherings. Please ensure that you've registered with your email
                ID before claiming the ticket.
              </p>
            ) : (
              <p className="font-medium text-[#1e1e1e] text-[16px] md:text-[18px] py-3 gt-w">
                Your ticket has been claimed! 🎉
              </p>
            )}

            <div className="button__container text-center">
              {!wallet ? (
                <div className="button-div">
                  {window && window.ethereum ? (
                    <button
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        activate(connectors.injected);
                        setProvider("injected");
                      }}
                      className="flex items-center justify-center gap-3 bg-[#1E1E1E] w-full px-5 py-4 my-2 rounded-full text-white font-semibold"
                    >
                      <img src={metamaskIcon} className="h-5 mr-2" alt="" />
                      <span>Metamask</span>
                    </button>
                  ) : null}
                  <button
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      activate(connectors.walletConnect);

                      setProvider("walletConnect");
                    }}
                    className="flex items-center justify-center gap-3 bg-[#8338E3] w-full px-5 py-4 my-2 rounded-full text-white font-semibold"
                  >
                    <img src={walletconnectIcon} className="h-5 mr-2" alt="" />
                    <span>Wallet Connect</span>
                  </button>
                </div>
              ) : !isClaimed ? (
                <button
                  className="bg-[#8338E3] w-full px-5 py-3 my-3 rounded-full text-white font-semibold text-center"
                  onClick={claim}
                >
                  Claim
                </button>
              ) : (
                <>
                  {/* <button className="bg-[#1E1E1E] w-full px-5 py-3 my-2 rounded-full text-white font-semibold text-center">
                    Claimed !
                  </button> */}

                  {mintedTokenId ? (
                    <button
                      onClick={() =>
                        window.open(
                          `https://mintnft.today/view/matic/0x03e055692e77e56abf7f5570d9c64c194ba15616/${mintedTokenId}`
                        )
                      }
                      className="bg-[#8338E3] w-full px-5 py-3 my-2 rounded-full text-white font-semibold text-center"
                    >
                      View Here
                    </button>
                  ) : null}
                </>
              )}
            </div>
          </div>
        </div>
      </ClaimBlock>
      {/* { : null} */}
      {isLoading ? (
        <div className="fixed z-20 inset-0 h-[100vh] bg-[#000a] flex items-center justify-center ">
          <div className="text-center">
            <ClipLoader size={60} color="#8338E3" />
            <p className="text-white font-semibold py-3">{loadingMessage}</p>
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default Claimpage;
